import { getDetailsCount, getNumberOfResultsString } from '../utils/search';

function renderPageImage(page) {
  if (page.image === null || page.image === undefined) {
    return '';
  }

  return `
    <div class="placeholder-background placeholder-background--animation" data-image-placeholder aria-hidden="true"></div>
    <img class="predictive-search-item__image lazyload"
      src="${page.image.url}"
      data-src="${page.image.url}"
      data-image
      alt="${page.image.alt}"
    />
  `;
}

function renderItemImageSection(product) {
  if (product.image === null || product.image === undefined) {
    return ' ';
  }

  return `
    <div class="predictive-search__column predictive-search__column--image" data-image-with-placeholder-wrapper>
      ${renderPageImage(product)}
    </div>`;
}

export default (page, index, resultsCount) => `
    <li id="search-result-${index}" class="predictive-search-item" role="option" data-search-result>
      <a class="predictive-search-item__link" href="${page.url}" tabindex="-1">
        ${renderItemImageSection(page)}
        <div class="predictive-search__column predictive-search__column--content ${
          getDetailsCount() ? '' : 'predictive-search__column--center'
        }">
          <span class="predictive-search-item__title">
            <span class="predictive-search-item__title-text">${page.title}</span>
          </span>
          <span class="vh">, </span>
          <span class="vh">${getNumberOfResultsString(index + 1, resultsCount)}</span>
        </div>
      </a>
    </li>
  `;
